import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./forms/Footer";
import HamburgerMenu from "./HamburgerMenu";
import "./LayOut.css";


const Layout = () => {
    const location = useLocation();
    const isHome = location.pathname === "/";

    return (
    <>
    <HamburgerMenu />
    <NavBar />
    <Outlet />
    <Footer className={isHome ? "footer-on-home" : ""} />
    </>
    ); };

    export default Layout;